<template>
  <gw-listing class="a7-pessoa-listing" :refresh="refresh" :title="$t('Pessoa')"
  :default-filter-params="defaultFilterParams" modal-size="small"
  :entity-dto-rest-resource="entityDTORestResource"
  :presentation="presentation"
  >
    <gw-column field="status"/>
    <gw-column field="nome"/>
    <gw-column field="telefone"/>
    <gw-column field="celular"/>
    <gw-column field="cidade"/>
    <gw-column field="uf"/>
    <gw-column field="cep"/>
    <gw-column field="tipo"/>

    <template slot="filterBand">
      <gw-possible-value-filter-item :display-text="$t('Pessoa.ui.filtroStatus')"
        property-name="status" :possible-values="possibleValues.status"/>
      <gw-text-filter-item :display-text="$t('Pessoa.ui.filtroNome')"
        property-name="nome"/>
      <gw-text-filter-item :display-text="$t('Pessoa.ui.filtroRazaoSocial')"
        property-name="razaoSocial"/>
      <gw-text-filter-item :display-text="$t('Pessoa.ui.filtroDocumento')"
        property-name="documento"/>
      <gw-text-filter-item :display-text="$t('Pessoa.ui.filtroContato')"
        property-name="contato"/>
      <a7-estado-filter-item :display-text="$t('Pessoa.ui.filtroEstado')"
        property-name="estado"/>
      <a7-cidade-filter-item :display-text="$t('Pessoa.ui.filtroCidade')"
        property-name="cidade"/>
      <gw-possible-value-filter-item :display-text="$t('Pessoa.ui.filtroTipoPessoa')"
        property-name="tipoPessoa" :possible-values="possibleValues.tipoPessoa"/>
    </template>

    <template slot="editor" slot-scope="{ entity }">
      <gw-grouping-pane :title="$t('Global.ui.geral')">
        <gw-grid-container>
          <div class="gw-row">
            <gw-editor-field property="status" class="gw-col-4"/>
            <gw-editor-field property="tipo" class="gw-col-4" />
          </div>
          <div class="gw-row">
            <gw-editor-field property="nome" class="gw-col-12"/>
          </div>
          <div class="conteudo-pessoa-fisica" v-show="entity && entity.tipo == 'F'">
            <div class="gw-row">
              <gw-editor-field property="sexo" class="gw-col-3"/>
              <gw-editor-field property="dataNascimento" class="gw-col-6"/>
              <gw-editor-field property="estadoCivil" class="gw-col-3"/>
            </div>
          </div>
          <div class="conteudo-pessoa-juridica" v-show="entity && entity.tipo == 'J' ">
            <div class="gw-row">
              <gw-editor-field property="razaoSocial" class="gw-col-12"/>
            </div>
            <div class="gw-row">
              <gw-editor-field property="ramoAtividade" class="gw-col-12"/>
            </div>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
      <gw-grouping-pane :title="$t('Pessoa.ui.editor.documentacao')">
        <gw-grid-container>
          <div class="conteudo-pessoa-fisica" v-show="entity && entity.tipo == 'F'">
            <div class="gw-row">
              <gw-editor-field property="CPF" class="gw-col-3"/>
              <gw-editor-field property="identidade" class="gw-col-3"/>
              <gw-editor-field property="siglaOrgaoIdentidade" class="gw-col-3"/>
              <gw-editor-field property="estadoExpedidorIdentidade" class="gw-col-3">
                <a7-estado-entity-chooser slot-scope="{ entity, properties }"
                v-model="entity.estadoExpedidorIdentidade"
                v-bind="properties"
                />
              </gw-editor-field>
            </div>
          </div>
          <div class="conteudo-pessoa-fisica" v-show="entity && entity.tipo == 'J'">
            <div class="gw-row">
              <gw-editor-field property="CNPJ" class="gw-col-3"/>
              <gw-editor-field property="inscricaoMunicipal" class="gw-col-4"/>
            </div>
          </div>
          <div class="gw-row">
            <gw-editor-field property="inscricaoEstadual" class="gw-col-3"/>
            <gw-editor-field property="estadoExpedidorInscricaoEstadual" class="gw-col-6">
              <a7-estado-entity-chooser slot-scope="{ entity, properties }"
              v-model="entity.estadoExpedidorInscricaoEstadual"
              v-bind="properties"
              />
            </gw-editor-field>
            <gw-editor-field property="isentoInscricaoEstadual" class="gw-col-3"/>
          </div>
        </gw-grid-container>
      </gw-grouping-pane>
    </template>

  </gw-listing>
</template>

<script>
/*
* @references
*   UI0005
*/
import {
  GwListing,
  GwTextFilterItem,
  GwPossibleValueFilterItem,
  GwColumn,
  GwEditorField,
  GwGroupingPane,
  GwGridContainer,
  FilterUtilities,
} from "guaxinim-web";
import PessoaRestResource from './PessoaRestResource'
import A7EstadoFilterItem from '../estado/A7EstadoFilterItem'
import A7CidadeFilterItem from '../cidade/A7CidadeFilterItem'
import A7EstadoEntityChooser from '../estado/A7EstadoEntityChooser'

export default {
  name: "a7-pessoa-listing",
  components: {
    GwListing,
    GwTextFilterItem,
    GwPossibleValueFilterItem,
    GwColumn,
    GwEditorField,
    GwGroupingPane,
    GwGridContainer,
    A7EstadoFilterItem,
    A7CidadeFilterItem,
    A7EstadoEntityChooser
  },
  props: {
    defaultFilterParams: {
      type: Object,
      default: () => ({
        status: ["A"]
      })
    }
  },
  data() {
    return {
      entityDTORestResource: PessoaRestResource,
      presentation: null,
      possibleValues: {
        status: [
          {description: this.$t('Pessoa.status.A'), value: 'A'},
          {description: this.$t('Pessoa.status.I'), value: 'I'}
        ],
        tipoPessoa: [
          {description: this.$t('Pessoa.tipo.F'), value: 'F'},
          {description: this.$t('Pessoa.tipo.J'), value: 'J'}
        ]
      }
    }
  },
  methods: {
    refresh(filterParams) {
      return this.entityDTORestResource.findDTOs(null,
        FilterUtilities.createFilterParamsString(filterParams));
    },
    search(pattern) {
      return this.entityDTORestResource.findPessoaFinderDTO(null, pattern, 10);
    },
    findEntityByID(id) {
      return this.entityDTORestResource.findPessoaFinderDTOByID(id);
    }
  },
  created() {
    this.entityDTORestResource.getDtoPresentation()
      .then(presentation => this.presentation = presentation)
      .catch((err) => this.$gw.defaultExceptionHandler.handleUnknowException(err, this));
  }
};
</script>

<style lang="scss" scoped></style>